// export enum StatusMedicaoEnum {
//   APROVADA = 'A',
//   REPROVADA = 'C',
//   PENDENTE = 'G',
// }
export enum StatusMedicaoEnum {
  A = 'Aprovada',
  C = 'Reprovada',
  G = 'Pendente de Aprovação',
}
